// CompaniesList/index.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Button } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import EditCompanyDialog from '../../containers/EditCompanyDialog';

import { companyStatus } from '../../constants';
import DeativeOrDeleteCompanyDialog from './../../containers/DeativeOrDeleteCompanyDialog';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  companyName: {
    fontSize: 18,
    fontWeight: 800,
    paddingTop: theme.spacing(1)
  },
  email: {
    paddingTop: theme.spacing(1)
  },
  deactivateContainer: {
    paddingTop: theme.spacing(2)
  },
  editDeleteContainer: {
    // paddingTop: theme.spacing(1)
  },
  editButton: {
    color: theme.palette.secondary.main
  },
  deleteButton: {
    color: theme.palette.danger.main
  }
}));

const SingleCompany = (props) => {
  const classes = useStyles();
  const {
    company,
    handleCompanyEditClick,
    openDeleteOrDeactiveCompanyDialog
  } = props;

  const companyId = company.id;

  return (
    <React.Fragment>
      <Paper>
        <div className={classes.container}>
          <Grid container>
            <Grid item xs={6}>
              <div className={classes.companyDetails}>
                <Typography variant="h3" className={classes.companyName}>
                  {company && company.name}
                </Typography>
                <Typography variant="subtitle1" className={classes.email}>
                  {company && company.email}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.deactivateContainer}>
                <Button
                  startIcon={<BlockIcon />}
                  onClick={() =>
                    openDeleteOrDeactiveCompanyDialog(
                      true,
                      companyId,
                      companyStatus.DEACTIVE
                    )
                  }
                  style={{ visibility: 'hidden' }}
                >
                  Deactivate
                </Button>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.editDeleteContainer}>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() => handleCompanyEditClick({ ...company })}
                >
                  Edit
                </Button>
                <br />
                <Button
                  startIcon={<DeleteOutlineIcon />}
                  className={classes.deleteButton}
                  onClick={() =>
                    openDeleteOrDeactiveCompanyDialog(
                      true,
                      companyId,
                      companyStatus.DELETE
                    )
                  }
                >
                  Delete
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </React.Fragment>
  );
};

function CompaniesList(props) {
  const {
    fetchAllCompanies,
    companies,
    onCompanyEditClick,
    openDeleteOrDeactiveCompanyDialog
  } = props;
  const classes = useStyles();

  React.useEffect(() => {
    fetchAllCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlDeleteOrDeactiveCompanyDialog = (open, companyId, status) => {
    openDeleteOrDeactiveCompanyDialog(open, companyId, status);
  };

  const handleCompanyEditClick = (company) => {
    onCompanyEditClick(company);
  };

  if (!companies) {
    return null;
  }

  return (
    <React.Fragment>
      <DeativeOrDeleteCompanyDialog />
      <EditCompanyDialog />
      <div className={classes.companiesListContainer}>
        {companies &&
          companies.map((company) => {
            return (
              <SingleCompany
                company={company}
                key={company.id}
                openDeleteOrDeactiveCompanyDialog={
                  handlDeleteOrDeactiveCompanyDialog
                }
                handleCompanyEditClick={handleCompanyEditClick}
              />
            );
          })}
      </div>
    </React.Fragment>
  );
}

export default CompaniesList;
